import React from 'react';
import { Box, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const TeamMemberPopup = ({ member, onClose }) => {
  if (!member) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        p: { xs: 2, sm: 4 },
      }}
      onClick={onClose}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '1rem',
          width: '100%',
          maxWidth: '600px',
          position: 'relative',
          padding: { xs: '1.5rem', sm: '2rem' },
          maxHeight: { xs: '85vh', sm: '90vh' },
          overflowY: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: { xs: '0.5rem', sm: '1rem' },
            top: { xs: '1rem', sm: '1.5rem' },
            color: '#FF5B36',
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: '1.1rem', sm: '1.4rem' },
            mb: { xs: 1.5, sm: 2 },
            pr: { xs: '2rem', sm: 0 }, // Space for close button
          }}
        >
          Meet Our Team
        </Typography>

        <Divider sx={{ mb: { xs: 2, sm: 3 } }} />

        {/* Content Container */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: '1.5rem', sm: '2rem' },
          }}
        >
          {/* Image Section */}
          <Box
            sx={{
              flex: '0 0 auto',
              width: { xs: '100%', sm: '200px' },
              height: { xs: '250px', sm: '250px' },
              position: 'relative',
              borderRadius: '1rem',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <img
              src={member.Image}
              alt={member.Name}
              style={{
                height: '100%',
                objectFit: 'cover',
                borderRadius: '1rem',
              }}
            />
          </Box>

          {/* Text Content */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: '1.1rem', sm: '1.5rem' },
                mb: { xs: 1.5, sm: 2 },
                textAlign: {xs: "center", sm: "left"}
              }}
            >
              {member.Name}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: '0.85rem', sm: '1rem' },
                lineHeight: 1.6,
                color: '#666',
                mb: { xs: 2, sm: 3 },
              }}
            >
              {member["Personal Side"]}
            </Typography>

            {member["LinkedIn Profile"] && (
              <Box 
                sx={{ 
                  display: 'flex',
                  justifyContent: 'center',
                  mt: { xs: 2, sm: 4 },
                }}
              >
                <a
                  href={member["LinkedIn Profile"]}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    padding: '0.8rem 2rem',
                    backgroundColor: '#FF5B36',
                    color: '#fff',
                    textDecoration: 'none',
                    borderRadius: '0.5rem',
                    fontSize: '0.9rem',
                    textAlign: 'center',
                    width: '100%',
                    maxWidth: '250px',
                  }}
                >
                  View LinkedIn Profile
                </a>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TeamMemberPopup; 